export default "__VITE_ASSET__2c478ffd__"